
export const profileIDFromAssetURL = (assetURL: string): string => {
    const u = URL.parse(assetURL)
    if (!u) {
        throw `expected asset URL ${assetURL} to be a valid path`
    }
    const path = u.pathname.split("/").filter((part) => Boolean(part))
    if (path.length < 4) {
        throw `expected asset URL ${assetURL} to have at least 4 parts`
    }
    if (path[0] != "assets") {
        throw `expected asset URL ${assetURL} to start with "/assets/"`
    }
    return path.slice(1, 4).join("")
}

export const cleanAssetURL = (url: string): string => {
    const parts = url.split("?")
    return parts[0]
}

